import {
  LIBRARY_GET_RECOMMENDED_REQUESTING,
  LIBRARY_GET_RECOMMENDED_ERROR,
  LIBRARY_GET_RECOMMENDED_SUCCESS,
  LIBRARY_GET_ALL_SUCCESS,
  LIBRARY_GET_ALL_ERROR,
  LIBRARY_GET_ALL_REQUESTING,
  LIBRARY_GET_PREMIUM_REQUESTING,
  LIBRARY_GET_PREMIUM_ERROR,
  LIBRARY_GET_PREMIUM_SUCCESS,
  LIBRARY_CLICK_TOPIC,
  LIBRARY_TOPIC_FEEDBACK_IDEA_CHANGE,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_SUCCESS,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_ERROR,
} from "./constants";

import { LOGOUT } from "../login/constants";
import { ILibraryReducer } from "./types";

const initialState: ILibraryReducer = {
  requesting: false,
  allRequesting: false,
  premiumRequesting: false,
  recommendedRequesting: false,
  errors: "",
  userTopicChoices: [],
  topicOptions: [
    {
      title: { fr: "Gestion du stress", en: "Stress Management" },
      value: "stress-management",
    },
    {
      title: { fr: "Gestion des conflits", en: "Conflicts management" },
      value: "conflict-management",
    },
    {
      title: { fr: "Anglais des affaires", en: "Business english" },
      value: "business-english",
    },
    {
      title: { fr: "Passer en mode Agile", en: "Adopting Agile methodology" },
      value: "adopting-agile",
    },
    {
      title: {
        fr: "Communiquer de manière efficace",
        en: "Communicate efficiently",
      },
      value: "communicate-efficiently",
    },
    {
      title: {
        fr: "Collaborer avec les millennials",
        en: "Collaborate with millenials",
      },
      value: "collaborate-millennials",
    },
  ],
  topicFeedbackIdea: "",
  recommendedCampaigns: [],
  premiumCampaigns: [],
  allCampaigns: [],
};

const reducer = function actionReducer(
  state: ILibraryReducer = initialState,
  action,
): ILibraryReducer {
  switch (action.type) {
    case LIBRARY_GET_ALL_REQUESTING: {
      return {
        ...state,
        allRequesting: true,
      };
    }

    case LIBRARY_GET_PREMIUM_REQUESTING:
      return {
        ...state,
        premiumRequesting: true,
      };

    case LIBRARY_GET_RECOMMENDED_REQUESTING: {
      return {
        ...state,
        recommendedRequesting: true,
      };
    }

    case LIBRARY_CLICK_TOPIC: {
      const userTopicChoices = state.userTopicChoices.filter(
        el => el.value !== action.payload.value,
      );
      if (userTopicChoices.length === state.userTopicChoices.length) {
        userTopicChoices.push(action.payload);
      }
      return {
        ...state,
        userTopicChoices,
      };
    }

    case LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case LIBRARY_SUBMIT_TOPIC_FEEDBACK_ERROR:
      return {
        ...state,
        requesting: false,
      };

    case LIBRARY_SUBMIT_TOPIC_FEEDBACK_SUCCESS:
      return {
        ...state,
        topicFeedbackIdea: "",
        requesting: false,
      };

    case LIBRARY_TOPIC_FEEDBACK_IDEA_CHANGE:
      return {
        ...state,
        topicFeedbackIdea: action.payload,
      };

    case LIBRARY_GET_ALL_SUCCESS:
      return {
        ...state,
        allRequesting: false,
        allCampaigns: action.payload,
      };

    case LIBRARY_GET_PREMIUM_SUCCESS:
      return {
        ...state,
        premiumRequesting: false,
        premiumCampaigns: action.payload,
      };

    case LIBRARY_GET_RECOMMENDED_SUCCESS:
      return {
        ...state,
        recommendedRequesting: false,
        recommendedCampaigns: action.payload,
      };

    case LIBRARY_GET_RECOMMENDED_ERROR:
      return {
        ...state,
        recommendedRequesting: false,
        errors: action.payload,
      };

    case LIBRARY_GET_ALL_ERROR:
      return {
        ...state,
        allRequesting: false,
        errors: action.payload,
      };

    case LIBRARY_GET_PREMIUM_ERROR:
      return {
        ...state,
        premiumRequesting: false,
        errors: action.payload,
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
